(function () {
    'use strict';
    /*
     * Copyright (c) 2019 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('scripForm', ScripForm);

    /**
     * A directive for displaying and editing prescription form information (everything from the name through all the flag options,
     * but not the contained prescription exercise templates.
     *
     * @ngdoc directive
     * @name scrip-form
     * @memberOf therapist
     * @example
     * <scrip-form
     *    edit-flag="isEdit"
     *    prescriptionObject="prescription"
     *    prescriptionObjectEdit="prescriptionTemp"
     * </scrip-form>
     */
    function ScripForm() {
        return {
            restrict: 'AE',
            transclude: false,
            scope: {
                /**
                 * The scope variable used to track view and edit mode.
                 */
                editFlag: '=',

                /**
                 * The object that contains the prescription values in view mode.
                 */
                prescriptionObject: '=',

                /**
                 * The object that contains the prescription values in edit mode.
                 */
                prescriptionObjectEdit: '=',

                /**
                 * Indicates whether to enable the setting of a prescribed date (even in the future).
                 */
                enablePrescribeDate: '=',

                /**
                 * Indicates whether to enable the processing of the enableAfterDays attribute.
                 */
                enableExpireAfterDays: '=',

                /**
                 * Indicates whether to show the gamify sequence option.
                 */
                enableGamifySequence: '='
            },
            controller: 'ScripFormCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'scrip-form/scrip-form.tpl.html'
        };
    }
})();